<div appObserveVisibility (visible)="getFeaturedTestimonies()"></div>

<section class="section_major" [class.onLanding]="onLanding">
  <div class="container--landing">
    <div class="oval1"></div>
    <div class="oval2"></div>

    <div class="block-nnki-title">
      <div class="swiper-nav -white">
        <div class="swiper-button-prev" id="prev-landingTestimonies">
          <svg-icon
            src="assets/images/svg-icons/icon-swiper-prev.svg"
            [svgStyle]="{ 'width.px': '10' }"
          ></svg-icon>
        </div>
        <div class="swiper-button-next" id="next-landingTestimonies">
          <svg-icon
            src="assets/images/svg-icons/icon-swiper-next.svg"
            [svgStyle]="{ 'width.px': '10' }"
          ></svg-icon>
        </div>
      </div>
    </div>

    <div class="block-with-slider">
      <div #landingTestimoniesSwiper class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide -major" *ngFor="let testimony of landingTestimonies">
            <div class="flex flex-wrap md:flex-nowrap items-start justify-center relative">
              <div
                class="md:mt-20 w-full max-w-xl md:w-[350px] text-theme-white mx-auto md:mr-0 md:ml-20 lg:ml-8"
              >
                <div
                  class="quote-content relative font-landing font-semibold text-36 leading-none mb-8 md:mb-16 ml-24 md:ml-0"
                >
                  <svg-icon
                    class="quote-open"
                    src="assets/images/svg-icons/icon-quote-open.svg"
                    [svgStyle]="{ 'width.px': '51' }"
                  ></svg-icon>
                  {{ testimony.quote }}
                  <svg-icon
                    class="quote-close"
                    src="assets/images/svg-icons/icon-quote-close.svg"
                    [svgStyle]="{ 'width.px': '40' }"
                  ></svg-icon>
                </div>
                <div class="border-t border-dashed border-theme-white"></div>
                <div class="mt-8 md:mt-14 font-landing font-semibold text-31">
                  {{ testimony.firstName }}
                </div>
                <div class="font-bold text-18">
                  {{ testimony.ecnRank }}
                </div>
              </div>
              <div
                class="testimony rounded shadow border border-site-theme-main-two bg-theme-white relative m-8 mt-52 md:m-0"
              >
                <div
                  class="p-14 pt-20 md:p-24 font-semibold italic text-14 space-y-8"
                  [innerHTML]="testimony.content"
                ></div>
                <div
                  *ngIf="testimony.picture"
                  class="testimony-photo rounded-full overflow-hidden shadow bg-white flex-center"
                >
                  <img [src]="testimony.picture" alt="" class="rounded-full object-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
